import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/legal")({
  pendingComponent: PagePending,
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: "Legal Terms",
  }),
});
